'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { track } from '@/lib/analytics';

export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    track('web-vitals', {
      metric: metric.name,
      value: metric.value,
      id: metric.id,
      rating: metric.rating,
    });
  });
  return null;
}
